import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import functions from "../../../util/functions";
import ActivityLoader from "../../Common/ActivityLoader";

const BillingOverview = ({ summaryData }) => {
  const [chartData, setChartData] = useState(false);

  useEffect(() => {
    if (functions.isObject(summaryData)) {
      // Ensure values are numbers to avoid the "map is not a function" error
      const billed = Number(summaryData.total_billed) || 0;
      const discount = Number(summaryData.total_discount) || 0;

      setChartData({
        series: [billed, discount],
        options: {
          chart: {
            type: "donut",
          },
          labels: ["Total Billed", "Total Discounted"],
          stroke: {
            show: true,
            width: 2,
            colors: ["#fff"],
          },
          plotOptions: {
            pie: {
              donut: {
                size: '75%', // Thinner donut for a more elegant look
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total Value',
                    fontSize: '12px',
                    color: '#94a3b8',
                    formatter: () => functions.numberFormat(billed + discount)
                  }
                }
              }
            }
          },
          dataLabels: {
            enabled: false, // Cleaner look without labels inside the slices
          },
          legend: {
            position: "bottom",
            fontFamily: 'inherit',
            fontSize: '12px',
            markers: { radius: 12 },
            itemMargin: { horizontal: 10, vertical: 5 }
          },
          colors: ['#4f46e5', '#10b981'], // Indigo and Emerald
          tooltip: {
            y: {
              formatter: (val) => `UGX ${functions.numberFormat(val)}`
            }
          }
        },
      });
    }
  }, [summaryData]);

  return (
    <div className="main-card mb-3 card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
      <div className="card-body p-4">
        <h6 className="text-uppercase text-muted fw-bold mb-4" style={{ fontSize: '11px', letterSpacing: '0.05rem' }}>
          Billed vs Discounted Fees
        </h6>
        
        <div style={{ minHeight: '230px' }}>
          {chartData ? (
            <Chart
              options={chartData.options}
              series={chartData.series}
              type="donut"
              height={250}
            />
          ) : (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '230px' }}>
              <ActivityLoader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillingOverview;